import { DueData } from '@/config/types';
import showError from '@/handler/error';
import { apiConfig, refreshTmxToken } from '../api-config';

export const generatePenalty = async (dueDataRequest: DueData) => apiConfig
  .post('api/payment/get-due-data', dueDataRequest, { headers: { authorization: sessionStorage.getItem('chave')?.toString() } })
  .then((e) => e)
  .catch(async (error) => {
    if (error.response.status === 401) {
      await refreshTmxToken();
      return generatePenalty(dueDataRequest);
    }
    showError(error);
    return false;
  });
